const CategoriesBtnData = [
    {
        id: 1,
        bgColor: "#FA5738",
        activeBgColor: "#dd6b20",
    },
    {
        id: 2,
        bgColor: "#212121",
        activeBgColor: "#dd6b20",

    },
    {
        id: 3,
        bgColor: "#23B5D3",
        activeBgColor: "#dd6b20",
    },
    {
        id: 4,
        bgColor: "#9461FF",
        activeBgColor: "#dd6b20",
    },
    {
        id: 5,
        bgColor: "#0C3B66",
        activeBgColor: "#dd6b20",
    },
    // {
    //     id: 5,
    //     bgColor: "#38fa4b",
    //     activeBgColor: "#2add20",
    // },
    // {
    //     id: 2,
    //     bgColor: "#0f1539",
    //     activeBgColor: "#25265a",

    // },
    // {
    //     id: 3,
    //     bgColor: "#6623d3",
    //     activeBgColor: "#dd6b20",
    // },
    // {
    //     id: 4,
    //     bgColor: "#9461FF",
    //     activeBgColor: "#dd6b20",
    // },
    // {
    //     id: 5,
    //     bgColor: "#0C3B66",
    //     activeBgColor: "#dd6b20",
    // },
];
export default CategoriesBtnData;